var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4575 1.65764C12.1849 1.44224 11.8001 1.44224 11.5275 1.65764L0.75 10.0651L1.68 11.2501L3 10.2151V19.5001C3 20.3286 3.67157 21.0001 4.5 21.0001H19.5C20.3284 21.0001 21 20.3286 21 19.5001V10.2226L22.32 11.2501L23.25 10.0726L12.4575 1.65764ZM13.5 19.5001H10.5V13.5001H13.5V19.5001ZM15 19.5001V13.5001C15 12.6717 14.3284 12.0001 13.5 12.0001H10.5C9.67157 12.0001 9 12.6717 9 13.5001V19.5001H4.5V9.04514L12 3.20264L19.5 9.05264V19.5001H15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.79cea4b642918913b838cdce2e4594af.svg";
export { ForwardRef as ReactComponent };